(() => {
  if (customElements.get('carisma-testimonials')) return;
  class CarismaTestimonials extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true; this.events = new AbortController();
      this.dialog = this.querySelector('dialog'); this.mount = this.querySelector('[data-video-mount]');
      const on = (node,event,fn) => node.addEventListener(event,fn,{signal:this.events.signal});
      this.querySelectorAll('[data-play]').forEach(button => {
        button.hidden = false;
        on(button,'click',()=>this.openVideo(button));
      });
      on(this.querySelector('[data-close]'),'click',()=>this.dialog.close());
      on(this.dialog,'close',()=>this.stopVideo());
      on(this.dialog,'click',event=>{
        if(event.target!==this.dialog)return;
        const r=this.dialog.getBoundingClientRect();
        if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();
      });
      on(document,'carisma:testimonial-play',event=>{if(event.detail!==this && this.dialog.open)this.dialog.close()});
    }
    disconnectedCallback(){this.events?.abort();this.stopVideo(false);if(this.dialog?.open)this.dialog.close();this.ready=false;}
    stopVideo(restoreFocus=true){this.mount?.querySelectorAll('video').forEach(v=>v.pause());this.mount?.replaceChildren();if(restoreFocus)this.trigger?.focus({preventScroll:true});this.trigger=null;}
    openVideo(button){
      document.dispatchEvent(new CustomEvent('carisma:testimonial-play',{detail:this}));
      this.stopVideo(false);this.trigger=button;
      const status=this.querySelector('[data-video-message]');status.textContent='';
      this.querySelector('[data-dialog-title]').textContent=button.dataset.name?`A story from ${button.dataset.name}`:'Customer story';
      const template=button.parentElement.querySelector('[data-hosted-video]');
      if(template){
        this.mount.append(template.content.cloneNode(true));
        const video=this.mount.querySelector('video');
        if(video){video.addEventListener('error',()=>{status.textContent='This video could not load. Please try again later.'},{once:true});}
      }else{
        const type=button.dataset.videoType,id=button.dataset.videoId;
        if((type==='youtube'&&!/^[\w-]{11}$/.test(id))||(type==='vimeo'&&!/^\d+$/.test(id))||!['youtube','vimeo'].includes(type)){status.textContent='Please check this video link in the Theme Editor.';this.dialog.showModal();return;}
        const url=new URL(type==='youtube'?`https://www.youtube-nocookie.com/embed/${id}`:`https://player.vimeo.com/video/${id}`);
        url.searchParams.set('autoplay',this.dataset.autoplay==='true'?'1':'0');url.searchParams.set('playsinline','1');
        const frame=document.createElement('iframe');frame.src=url.href;frame.title=`Video from ${button.dataset.name||'a customer'}`;frame.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';frame.allowFullscreen=true;frame.referrerPolicy='strict-origin-when-cross-origin';this.mount.append(frame);
      }
      if(!this.dialog.open)this.dialog.showModal();
      const video=this.mount.querySelector('video');
      if(video && this.dataset.autoplay==='true')video.play().catch(()=>{status.textContent='Press play to start the video.'});
    }
  }
  customElements.define('carisma-testimonials',CarismaTestimonials);
})();
